import { render, staticRenderFns } from "./luas_tanaman_padi.vue?vue&type=template&id=3d595f40&"
import script from "./luas_tanaman_padi.vue?vue&type=script&lang=js&"
export * from "./luas_tanaman_padi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports